import React from 'react'
import { useTranslation } from 'react-i18next'

function OrderOverviewResultsTooltip() {

    const { t } = useTranslation();

    return (

        <span class='element ml-1'>
            <svg
                width='18'
                height='18'
                fill='none'
                className='inline'
            >
                <path
                    d='M9 0C4.036 0 0 4.036 0 9s4.036 9 9 9 9-4.036 9-9-4.036-9-9-9Zm0 1.2A7.79 7.79 0 0 1 16.8 9c0 4.315-3.485 7.8-7.8 7.8A7.79 7.79 0 0 1 1.2 9 7.79 7.79 0 0 1 9 1.2ZM9 4C7.35 4 6 5.35 6 7a.6.6 0 1 0 1.2 0C7.2 5.999 8 5.2 9 5.2S10.8 6 10.8 7c0 .623-.251 1.048-.663 1.481-.411.434-.982.826-1.512 1.25a.6.6 0 0 0-.225.47V11a.6.6 0 1 0 1.2 0v-.506c.437-.334.95-.701 1.412-1.188C11.551 8.74 12 7.974 12 7c0-1.65-1.35-3-3-3Zm0 8.4A.8.8 0 1 0 9 14a.8.8 0 0 0 0-1.6Z'
                    fill='#231F20'
                />
            </svg>
            <div
                className='statustooltip tooltip-status absolute bg-white h-auto rounded-sm status-checked text-[12px] w-auto z-10'
            >
                <div className='flex flex-row font-normal pb-1 pt-1'>
                    <ul>
                        <li className='pb-2.5 under-review'>
                            <div className='flex'>
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M16.667 5L7.5 14.167L3.333 10"
                                        stroke="#595959"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                <p className='font-normal ml-2'>
                                    {t("Pass")}
                                </p>
                            </div>
                        </li>
                        <li className='pb-2.5 under-review'>
                            <div className='flex'>
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M15 5L5 15M5 5L15 15"
                                        stroke="#595959"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                <p className='font-normal ml-2'>
                                    {t("Fail")}
                                </p>
                            </div>
                        </li>
                        <li className='pb-2.5 under-review'>
                            <div className='flex'>
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="10"
                                        cy="10"
                                        r="8.333"
                                        stroke="#595959"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        d="M10 6.667V10L12.5 11.667"
                                        stroke="#595959"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                <p className='font-normal ml-2'>
                                    {t("Pending")}
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </span>
    )
}

export default OrderOverviewResultsTooltip
